// extracted by mini-css-extract-plugin
module.exports = {"button":"TrustBannerItem_button__9STVa","title":"TrustBannerItem_title__ZdxSf","item":"TrustBannerItem_item__tLUnA"};